import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '$store/rootReducer';
import {
  ConnectChannelAction,
  LoadDashboardSuccessAction,
  SetConnectedBotAction,
  TelegramState,
} from './interface';

const initialState: TelegramState = {
  botConnected: false,
  loadingStatus: 'loading',
  connectedChannel: null,
  inviteLink: '',
};

export const { actions, reducer } = createSlice({
  name: 'telegram',
  initialState,
  reducers: {
    loadDashboard(state) {
      state.loadingStatus = 'loading';
    },
    loadDashboardFailed(state) {
      state.loadingStatus = 'failed';
    },
    loadDashboardSuccess(state, action: LoadDashboardSuccessAction) {
      state.botConnected = action.payload.connected;
      state.loadingStatus = '';
    },
    setConnectedBot(state, action: SetConnectedBotAction) {
      state.botConnected = action.payload;
    },
    connectChannel(_, action: ConnectChannelAction) {},
    setConnectedChannel(state, action: PayloadAction<TelegramState['connectedChannel']>) {
      state.connectedChannel = action.payload;
    },
    setInviteLink(state, action: PayloadAction<TelegramState['inviteLink']>) {
      state.inviteLink = action.payload;
    },
  },
});

export { reducer as telegramReducer, actions as telegramActions };

export const telegramSelector = (state: RootState) => state.telegram;
